class DateFormatter{
    /**
   * Formats a given Date object or timestamp to 'yyyy-mm-dd'.
   * @param {Date | number} date - A Date object or a timestamp.
   * @returns {string} - The formatted date string in 'yyyy-mm-dd' format.
   */
  static formatDate(date) {


    if (date === null || date === undefined) {
      return 'N/A';
    }
    const d = date instanceof Date ? date : new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
}

export default DateFormatter;